import React from 'react';
export function AlignCenterVerticalIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11H3a1 1 0 100 2h1v3a2 2 0 002 2h12a2 2 0 002-2v-3h1a1 1 0 100-2h-1V8a2 2 0 00-2-2H6a2 2 0 00-2 2v3zm2-3h12v3H6V8zm12 5v3H6v-3h12z"
  }));
}